import { USER_SETTINGS_FORM } from './form-user-settings-types';
import { checkForSelectValue } from '../form-helpers';

import { updateSettingsUser } from '../../../routes/update-user-settings';

/**
 * Function to update the users settings
 * 
 * @returns void
 */
const UpdateUserSettings = () => {
  const {
    settingForm,
    settingFirstName,
    settingLastName,
    settingDisplayName,
    settingSubmit
  } = USER_SETTINGS_FORM;

  if ( !settingForm ) return;

  const validateForm = () => {
    settingForm.classList.add('was-validated');

    checkForSelectValue(settingDisplayName, 'User Name', 'user-name');

    return settingForm.checkValidity() && settingDisplayName.getAttribute('data-value') != null;
  }

  const handleSubmit = async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if ( validateForm() ) {
      settingForm.classList.remove('was-validated');
      settingForm.classList.remove('form-control:valid');
      settingSubmit.classList.add('aafp_button-loading');

      const wpModelData = {
        settingFirstName: settingFirstName.value,
        settingLastName: settingLastName.value,
        settingDisplayName: String(settingDisplayName.getAttribute('data-value'))
      };

      const { body } = await updateSettingsUser(wpModelData);
      if ( body ) {
        setTimeout(() => {
          location.reload();
        }, 1500);
      }  
    }
  }

  settingForm.addEventListener('submit', handleSubmit);
}

/**
 * Function to update the users color scheme
 * 
 * @returns void
 */
const updateUserColorScheme = () => {
  const themeSwitch = document.querySelector('.switch-button-checkbox') as HTMLInputElement;
  const currentTheme = document.documentElement;
  const currentState = localStorage.getItem('color-mode');

  if(!themeSwitch) return;

  themeSwitch.checked = currentState === 'dark';

  themeSwitch.addEventListener('click', () => {    
    const newColorMode = themeSwitch.checked ? 'dark' : 'light';
    currentTheme.setAttribute('color-mode', newColorMode);
    localStorage.setItem('color-mode', newColorMode);
  });
}

export default UpdateUserSettings;
export { updateUserColorScheme };